module.exports = __webpack_public_path__ + "img/photo-0123.03f9da50.jpg";